<template>
  <div>
    <div class="sign-consent-1 common-consent-edu" v-if="!isSignIn">
      <p class="edu-consent-text m-0 pt-0">
        <span v-if="consentObj.config.dataVantConsent" class="d-block" v-translate:rsb_datavant_review_reason="lang"
          >By providing your name and signature, you confirm that you 
          have read the information contained herein and would like to 
          proceed with tokenization/de-identification of your data.</span
        >
        <span v-else class="d-block" v-translate:consent_message="lang"
          >By providing your name and signature, you confirm that you read the
          information contained herein and that you wish to take part in this
          research study.</span
        >
      </p>
      <div id="sign-cosent-form">
        <div class="form-group consent-form-group">
          <input type="text" class="form-control" v-model="consentSign.firstName" aria-describedby="" v-translate:first_name.placeholder="lang" placeholder="First Name" />
        </div>
        <div class="form-group consent-form-group mb-0">
          <input type="text" class="form-control" v-model="consentSign.lastName" aria-describedby="" v-translate:last_name.placeholder="lang" placeholder="Last Name" />
        </div>
        <div class="text-center pt-48">
          <button class="btn btn-submit" :disabled="isFieldAdded" @click="onSingInClick" v-translate:text_signin_button="lang">
            Next
          </button>
        </div>
      </div>
    </div>
    <div class="sign-consent-2 common-consent-edu" v-if="isSignIn">
      <p class="verify-name m-0 pt-0" v-translate:rsb_consent_signature_title="lang">
        Signature
      </p>
      <p class="forgot-pwd-text pt-12 fs-17" v-translate:pw_consent_sign="lang">
        Please sign below.
      </p>
      <div class="consent-sign-pad pt-8">
        <Initial :lang="lang"></Initial>
      </div>
      <div class="text-center pt-48 btn-next">
        <button class="btn btn-submit" :disabled="getBase64InitialData === null" @click="onSignatureClick" v-translate:text_signin_button="lang">
          Next
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Initial from "@/components/common/initials";
import { Widget, ParticipantPortal, Consent } from "@/components/services/participant-service";

export default {
  name: "join-sign",
  components: { Initial },
  props: ["isOnBackClick", "lang", "currentConsent", "eConsentDetails"],
  data() {
    return {
      widget: new Widget(),
      portal: new ParticipantPortal(),
      consent: new Consent(),
      isParticipantAgreed: false,
      isSignIn: false,
      consentSign: {
        consentId: "",
        consentName: "",
        firstName: "",
        lastName: "",
        signature: ""
      }
    };
  },
  computed: {
    ...mapGetters(["participantRegistration", "getBase64InitialData"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    consentObj() {
      return this.consent.currentConsentObj;
    },
    getConsentID() {
      return this.consentObj && this.consentObj.config.consentId;
    },
    getConsentName() {
      return this.consentObj && this.consentObj.config.consentName;
    },
    isFieldAdded() {
      const { firstName, lastName } = this.consentSign;
      return !!(lastName.trim() == "" || firstName.trim() == "");
    }
  },
  watch: {
    isOnBackClick(val) {
      if (val) {
        if (this.consentObj.config.documentAndSignatureEnabled)
          this.$emit("updateConsentScreen", "disclaimer");
        else if (this.consentObj.config.educationEnabled)
          this.$emit("backButtonClick", "questions");
        else
          this.$emit("updateConsentScreen", "prev-consent");
      }
    }
  },
  mounted() {
    let i18KeyForConsentName = this.consentObj.config.dataVantConsent ? "datavant_consent_form_title" : `${this.consentObj.config.consentId}_consentName` ;
    let consentName = this.widget.i18nActivities(i18KeyForConsentName, this.lang);
    this.$emit("updateHeaderNav", {
      showBlankHeader: true,
      title: consentName ? consentName : this.consentObj.config.consentName,
    });
    this.setSignerName();
  },
  methods: {
    onSingInClick() {
      this.isSignIn = true;
    },
    setParticipantName() {
      const { firstName, lastName } = this.consentSign;
      this.participantRegistration.participantMeta.firstName = firstName;
      this.participantRegistration.participantMeta.lastName = lastName;
    },
    onSignatureClick() {
      this.consentSign.signature = this.getBase64InitialData;
      this.consentSign.consentId = this.getConsentID;
      this.consentSign.consentName = this.getConsentName;
      this.consentSign.dataVantConsent = this.consentObj.config.dataVantConsent ? true : false;

      this.setParticipantName();
      this.$emit("onSignature", this.consentSign);
      this.$emit("consentCompleted", "isConcentSignCompleted");
    },
    agreed() {
      this.isParticipantAgreed = true;
      this.$emit("updateHeaderNav", { showBlankHeader: true, title: "Verify" });
    },
    setSignerName() {
      if (this.participantRegistration.participantMeta.firstName && this.participantRegistration.participantMeta.firstName != "") {
        this.consentSign.firstName = this.participantRegistration.participantMeta.firstName;
      }
      if (this.participantRegistration.participantMeta.lastName && this.participantRegistration.participantMeta.lastName != "") {
        this.consentSign.lastName = this.participantRegistration.participantMeta.lastName;
      }
    }
  }
};
</script>
